import { configureStore } from "@reduxjs/toolkit";

import FAQSlice from "../Redux/FAQSlice";
import AnalyticsSlice from "../Redux/AnalyticsSlice";
import IndustryDataSlice from "../Redux/IndustryDataSlice";
import AdminSlice from "../Redux/AdminSlice";
import FlipbookDataSlice from "../Redux/FlipbookData";
import UserMaintenanceSlice from "../Redux/UserMaintenance";

export default configureStore({
  reducer: {
    faq: FAQSlice,
    analytics: AnalyticsSlice,
    industryData: IndustryDataSlice,
    admin: AdminSlice,
    flipbookData: FlipbookDataSlice,
    userMaintenance: UserMaintenanceSlice,
  },
});
